module.exports = __webpack_public_path__ + "img/10-top-mountain_v8e.a8a78538.png";